<!-- Shared by grid-checkbox-filter-menu and grid-checkbox-filter-menu-signal (WI 35564). -->
@let v = view();
@if (v.loading) {
  <div class="mb-5 mt-0">
    <span>
      <i class="fa fa-spinner fa-spin"></i>
      Loading filter data ...
    </span>
  </div>
} @else {
  @if (v.onlyBlank) {
    <div>
      <span class="ms-3 mb-5 mt-0">
        Only {{ v.blankText }} entries exist in this column.
      </span>
    </div>
  } @else {
    <ul [style.height.px]="v.height">
      @if (v.showFilter || v.showFilterOperators) {
        <li>
          @if (v.showFilterOperators) {
            <kendo-dropdownlist
              [value]="v.searchOperator"
              [data]="dataItemSearchOptions"
              [textField]="'text'"
              [valueField]="'value'"
              [valuePrimitive]="true"
              (selectionChange)="dataItemSearchFilterOperatorChange($event)"
            ></kendo-dropdownlist>
          }
          @if (v.showFilter) {
            <input
              #searchBox
              class="k-textbox"
              [value]="v.searchText"
              (input)="dataItemFilterTextChange(searchBox.value)"
            />
          }
        </li>
      }
      @if (v.addSelectAllOption) {
        <li>
          <input
            #selectAll
            type="checkbox"
            id="chk-select-all"
            class="k-checkbox"
            kendoCheckBox
            [checked]="v.allSelected"
            (change)="onSelectAllChange(selectAll.checked)"
          />
          <label
            class="k-checkbox-label k-checkbox-label-patch"
            for="chk-select-all"
          >
            Select All
          </label>
        </li>
      }
      @for (row of v.rows; track $index) {
        <li>
          <input
            #itemCheckbox
            type="checkbox"
            id="chk-{{ row.id }}"
            class="k-checkbox"
            kendoCheckBox
            [checked]="row.selected"
            (change)="onSelectionChange(itemCheckbox.checked, row.item)"
          />
          <label
            class="k-checkbox-label k-checkbox-label-patch"
            for="chk-{{ row.id }}"
            [attr.title]="row.hint"
          >
            {{ row.text }}
            @if (row.hint; as hint) {
              <span class="d-block small text-muted">{{ hint }}</span>
            }
          </label>
        </li>
      }
    </ul>
  }
}
